import * as Redux from '@reduxjs/toolkit';
import rootReducer from '../reducers/Reducers';


const store = Redux.configureStore({
    middleware: getDefaultMiddleware => getDefaultMiddleware({
        serializableCheck: false
    }),
    reducer: rootReducer
})

// const store = Redux.createStore(fileUploadReducer);

export default store;
